/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.0
 * @since 1.25.0
 */

import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { makeSelectTranslationPageSettings } from '@/main/modules/internationalization/intSelectors';
import { useModalOpenError } from '@/main/modules/modal/hooks/useModalOpenError';
import { useModalOpenSuccess } from '@/main/modules/modal/hooks/useModalOpenSuccess';

export const useStatusModals = (isLoading: boolean, isSuccess: boolean, isError: boolean) => {
    const settingsTranslation = useSelector(makeSelectTranslationPageSettings());

    const { open: openErrorModal } = useModalOpenError();
    const { open: openSuccesModal } = useModalOpenSuccess();

    useEffect(() => {
        if (!isLoading && isError) {
            openErrorModal('', settingsTranslation.settingsNotifications.modal.error);
        }
        // openErrorModal not memorized
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess, isLoading]);

    useEffect(() => {
        if (!isLoading && !isError && isSuccess) {
            openSuccesModal(settingsTranslation.settingsNotifications.modal.success);
        }
        // openSuccesModal not memorized
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isError, isLoading, isSuccess]);
};
